// extracted by mini-css-extract-plugin
export default {"errorWrapper":"errorWrapper--Gh4cM"};